import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LayoutGrid, Search, Wallet, } from 'lucide-react';
import { FaTwitter, FaGithub } from 'react-icons/fa'
// import logo_no_bg from './../media/img/jts_logo.png'
import cancel_icon from './../media/icons/close.png'
import nav_icon from './../media/icons/menu.png'
import { images } from '../utilities/img';


const Footer = () => {

    const windowscrollvalue = window.scrollY
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup: Remove the event listener when the component is unmounted
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    return ( 
        <>
            <div className="flex justify-flex-end info-connect-footer">
                <div className={`flex row align-center ${windowWidth < 600 ? 'gap-20' : 'gap-70'}`}>
                    <div className="icf-stable-conn row flex gap-10 align-center">
                        <div className=""></div>
                        <p className='hn_medium green'>Stable Connection</p>
                    </div>

                    <div className={`flex row align-center ${windowWidth < 600 ? 'gap-10' : 'gap-20'}`}>
                        <a href="https://x.com/evalysfun/" target='_blank' className='flex align-center'><FaTwitter size={15} className='d-white_c' /></a>
                        <a target='_blank' href='https://github.com/evalysfun' className="flex row gap-10 align-center">
                            <FaGithub size={20} className='d-white_c' />
                            <p className="hn_medium d-white_c">Github</p>
                        </a>
                    </div>
                </div>
            </div>

        </>
    );
}
 
export default Footer;